<template>
	<CardContent
		:class="cn(propertyCardContentVariants({ variant }), props.class)"
	>
		<BrokerAvatarInfo
			:class="cn(propertyCardBrokerVariants({ variant }), 'gap-9')"
			:info-classes="{
				wrapper: 'text-white',
				brokerName: 'text-[14px] leading-[20px]',
				companyName: 'text-[12px] leading-[18px]'
			}"
			avatar-shape="circle"
			avatar-class="h-[36px] w-[36px]"
			sizes="linear"
			:broker-src="brokerSrc || ''"
			:linear-sizes="true"
			:company-src="property.company?.smallLogo || ''"
		>
			<template #broker> {{ agentName }} </template>
			<template #company> {{ property.company?.name }} </template>
		</BrokerAvatarInfo>
	</CardContent>
</template>

<script setup lang="ts">
import { cn } from '@/utils';
import type { Property } from '~/core/entities/property';
import { propertyCardContentVariants, propertyCardBrokerVariants } from '.';
import { BrokerAvatarInfo } from '../BrokerAvatarInfo';
import { CardContent } from '../ui/card';
import { getAgentName } from '~~/utils';
import { useImage } from '#imports';

const props = defineProps<{
	class?: string;
	variant: 'whiteBackground' | 'transparentBackground' | 'fullFace';
	property: Property;
}>();

const getImageSrc = useImage();

const brokerSrc = computed(() =>
	getImageSrc(
		props.property.agent?.profilePicture.croppedUrl || '',
		{
			format: 'webp',
			width: 72
		},
		{
			provider: 'AWSServerlessImageHandler'
		}
	)
);

const agentName = computed(() => getAgentName(props.property.agent));
</script>
